export default "__VITE_ASSET__Cj2BeLP6__"